import { Tab, TabBar } from "@rmwc/tabs";
import '@rmwc/tabs/styles';
import { Theme } from "@rmwc/theme";
import { TAB_DISTRIBUTION, TAB_MAP } from "App/Constants";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import "./BottomNavBar.css";

// #region FONCTION COMPOSANT
/**
 * Composant permettant d'afficher la barre de navigation
 * @category BottomNavBar
 * @param {BottomNavBar.propTypes} props Les propriétés du composant
 */
function BottomNavBar(props) {
  //#region INITIALISATION
  // Récupération des props
  const {
    activeTabIndex,
    onChangeActiveTab
  } = props;
  // Traduction i18n (i18n.language en key pour remonter le TabBar au changement de langue et éviter la désync)
  const { t, i18n } = useTranslation();
  // #endregion

  // #region EVENTS

  //AYB 2025.11.14 Gestion explicite de l'onglet déclenché par RMWC pour éviter les boucles d'activation
  // const handleChangeTab = () => {
  //   let result = activeTabIndex;
  //
  //   if (activeTabIndex === TAB_MAP) {
  //     result = TAB_DISTRIBUTION;
  //   } else {
  //     result = TAB_MAP;
  //   }
  //
  //   onChangeActiveTab(result);
  // };
  const handleChangeTab = (event) => {
    const nextIndex = event?.detail?.index;

    if (typeof nextIndex !== "number" || nextIndex === activeTabIndex) {
      return;
    }

    onChangeActiveTab(nextIndex);
  };
  // #endregion

  // #region INTERFACE
  return (
    <div className="BottomNavBar-Container">
      <Theme use={['onSecondary']} wrap>
        <TabBar
          key={i18n.language}
          activeTabIndex={activeTabIndex}
          className="TabBar"
          onActivate={(event) => handleChangeTab(event)}
        >
          <Tab
            icon="explore"
            style={{ color: "#FFF" }}
            label={t("accueil.map")}
            stacked
          />
          <Tab
            icon="update"
            label={t("accueil.distribution")}
            stacked
          />
        </TabBar>
      </Theme>
    </div >
  );
  // #endregion
};
// #endregion

// #region PROPRIETES
/**
 * Type des propriétés de {@link BottomNavBar}
 * @typedef {Object} BottomNavBar.propTypes
 * @property {number} activeTabIndex Indice de la TabBar sélectionnée
 * @property {function} onChangeActiveTab Fonction de callback lors de la sélection d'une TabBar
 */
BottomNavBar.propTypes = {
  activeTabIndex: PropTypes.number.isRequired,
  onChangeActiveTab: PropTypes.func.isRequired
};
// #endregion

export { BottomNavBar };

